import React, { Component } from 'react';

import './Toaster.css';

import Uuid from '../../support/Uuid';
import Toaster from './Toaster';

class ToastManager extends Component {

  state = {
    items: []
  }

  componentDidMount() {
    window.ToastManager = this;
  }

  show = (config) => {
    const { items } = this.state;
    const toast = {
      ...config,
      id: config.id || Uuid.v4()
    };

    this.setState({
      items: items.concat([toast])
    });

    return toast.id;
  }

  hide = (toast) => {
    this.handleOnClose(toast);
  }

  handleOnClose = (toast) => {
    const { items } = this.state;

    this.setState({
      items: items.filter((toaster) => toaster.id !== toast.id)
    });
  }

  renderToaster = (item) => {
    return <Toaster key={ item.id } data={ item } onClose={ this.handleOnClose } />
  }

  render() {
    const { items } = this.state;

    return (
      <div className="toaster-manager">
        <div className="toaster-container">
          { items.map(this.renderToaster) }
        </div>
      </div>
    )
  }
}

export default ToastManager;